module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_champagne-550afd45f5553c80303ec78deda35207.png";